var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon/search",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8316 20.7112C16.8697 22.4787 14.307 23.5487 11.5034 23.5487C5.332 23.5487 0.329102 18.3646 0.329102 11.9697C0.329102 5.57474 5.332 0.390625 11.5034 0.390625C17.6747 0.390625 22.6776 5.57474 22.6776 11.9697C22.6776 14.383 21.9654 16.6239 20.7463 18.4788L33.8529 32.0603L31.8184 34.1684L18.8316 20.7112ZM19.8005 11.9697C19.8005 16.7181 16.0859 20.5674 11.5034 20.5674C6.92085 20.5674 3.20616 16.7181 3.20616 11.9697C3.20616 7.22124 6.92085 3.3719 11.5034 3.3719C16.0859 3.3719 19.8005 7.22124 19.8005 11.9697Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0214147bfa2a43f3f6404fb65299008b.svg";
export { ForwardRef as ReactComponent };